import type { RootStateOrAny } from 'react-redux'
import type { Dispatch } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'

import { getAccessToken } from '../../../selectors/auth'
import * as feedbackApi from '../apis/feedback'

type GetState = () => RootStateOrAny

export const userRecipeRatings = () => async (dispatch: Dispatch, getState: GetState) => {
  const accessToken = getAccessToken(getState())
  const {
    data: {
      meta: { totalRecipeCount: feedbackCount },
    },
  } = await feedbackApi.getUserFeedbackCount(accessToken)

  dispatch({
    type: actionTypes.FEEDBACK_COUNT_RECEIVED,
    payload: feedbackCount,
  })
}

export const trackClickRateRecipes = (location: string) => (dispatch: Dispatch) => {
  const type = trackingKeys.clickRateRecipes

  dispatch({
    type,
    trackingData: {
      actionType: type,
      location,
    },
  })
}
